import React from "react";
import {
  Box,
  Chip,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 10,
    border: `1px solid ${theme.palette.primary.light}`,
  },
  bookCover: {
    width: "100%",
    height: 250,
    objectFit: "contain",
  },
  imgContainer: {
    width: "90%",
    maxWidth: 200,
    margin: "0 auto",
  },
  bookTitle: {
    fontSize: "18px",
    fontWeight: 500,
    marginTop: 0,
  },
  infoLabel: {
    width: 100,
    fontSize: 14,
    margin: 0,
    color: theme.palette.primary.dark,
    fontWeight: 450,
  },
  infoValue: {
    fontWeight: 400,
    textAlign: "left",
    fontSize: 14,
    margin: 0,
  },
  total: {
    color: "black",
    fontWeight: 500,
    fontSize: 16,
    marginTop: 0,
    marginBottom: -35,
    padding: 5,
  },
}));

function OrderCard({ order }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8} lg={9} xl={10}>
            <Typography variant="subtitle2" color="secondary">
              Current status - {order?.status || <Skeleton width={100} />}
            </Typography>
            <h2 className={classes.bookTitle}>
              {order?.book?.book_title || <Skeleton />}
            </h2>
            <Grid container spacing={2}>
            {order?.book?.isAuthorAdmin && order?.shipping_address && (
            <>
              <Grid item xs={12} lg={3} xl={2}>
                <h3 className={classes.infoLabel}>Delivery</h3>
              </Grid>
              <Grid item xs={12} lg={9} xl={10}>
                <p className={classes.infoValue}>
                  {order?.billing_details
                    ? `${order.billing_details.delivery_amount} $`
                    : <Skeleton width={50} />}
                </p>
              </Grid>
              </>
            )}
              {order?.book?.isAuthorAdmin && order?.shipping_address && (
                <>
                  <Grid item xs={12} lg={3} xl={2}>
                    <h3 className={classes.infoLabel}>Address</h3>
                  </Grid>
                  <Grid item xs={12} lg={9} xl={10}>
                    <p className={classes.infoValue}>
                      {order?.shipping_address?.name} ,{" "}
                      {order?.shipping_address?.city} ,{" "}
                      {order?.country}
                    </p>
                  </Grid>
                </>
              )}
              <Grid item xs={12} lg={3} xl={2}>
                <h3 className={classes.infoLabel}>Date</h3>
              </Grid>
              <Grid item xs={12} lg={9} xl={10}>
                <p className={classes.infoValue}>
                  {order
                    ? moment(order.date_updated).format("MMMM Do YYYY, h:mm a")
                    : <Skeleton width={150} />}
                </p>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} lg={3} xl={2}>
            <Box className={classes.imgContainer}>
              {order?.book?.book_cover ? (
                <img
                  src={order.book.book_cover}
                  className={classes.bookCover}
                />
              ) : (
                <Skeleton variant="rect" width={200} height={250} />
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box align="right">
        <Chip
          color="primary"
          className={classes.total}
          label={`Total - $${(
            (order?.book_price?.digital_price || 0) +
            (order?.billing_details?.tax_amount?.[0]?.amount || 0) +
            (order?.billing_details?.delivery_amount || 0)
          ).toFixed(2)}`}
        />
      </Box>
    </div>
  );
}

export default OrderCard;
